import uuid from 'uuid/v4';
import {action, computed, observable} from 'mobx';
import {isEmpty, some} from 'lodash';

export default class {
  @observable softCredits = new Map();
  @observable donationAmount = 0;
  @observable originalDonationId = '';
  @observable authToken = '';

  @computed get softCreditTotalAmountIsValid() {
    const softCreditTotalAmount = Array.from(this.softCredits.values()).reduce((acc, softCredit) => acc + Number(softCredit.amount), 0);
    return softCreditTotalAmount === this.donationAmount;
  }

  @computed get softCreditUsersAreValid() {
    return !some(Array.from(this.softCredits.values()), { value: ''});
  }

  @computed get usersAndAmountAreValid() {
    return this.softCreditTotalAmountIsValid && this.softCreditUsersAreValid;
  }

  @action addSoftCredit = () => {
    this.softCredits.set(uuid(), this.newSoftCredit());
  }

  @action deleteSoftCredit = (key) => {
    this.softCredits.delete(key);
  }

  @action resetSoftCreditUser = (key) => {
    this.softCredits.set(key, this.newSoftCredit());
  }

  @action updateSoftCreditAmount = (amount, key) => {
    this.softCredits.get(key).amount = amount;
  }

  @action updateSoftCreditUser = (newUser, key) => {
    this.softCredits.set(key, { ...this.softCredits.get(key), ...newUser });
  }

  @action validateSoftCreditsHaveUsers = () => this.userPresenceFailedValidation = some(Array.from(this.softCredits.values()), { value: ''});

  defaultSoftCreditAmount = () => isEmpty(this.softCredits) ? this.donationAmount : 0;

  newSoftCredit = () => ({
    name: '',
    email: '',
    account_type: '',
    address_line_1: '',
    address_line_2: '',
    address_city: '',
    address_state: '',
    address_zip: '',
    address_country: '',
    amount: this.defaultSoftCreditAmount(),
    value: '',
  });

  submit = () => {
    $.ajax({
      method: 'POST',
      url: '/admin/soft_credits',
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify({
        authenticity_token: this.authToken,
        original_donation_id: this.originalDonationId,
        soft_credits: Array.from(this.softCredits.values()).map(
          softCredit => (
            {
              user_id: softCredit.value,
              amount: softCredit.amount,
            }
          )
        ),
      }),
      success: function(data) {
        window.location.href = data;
      },
    });
  }
}
